import React, { useEffect, useState } from 'react';
import { Button, Form, Input, notification } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useLogin } from '../hooks/useLogin';
import { useAuthStore } from '../store';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const useAuth = useAuthStore();
  const navigate = useNavigate();

  const { mutate, isError, data, error, isSuccess } = useLogin();
  useEffect(() => {
    setClientReady(true);
  }, []);

  const onFinish = async (values: any) => {
    setLoading(true);
    mutate({ username: values.username, password: values.password });
  };

  useEffect(() => {
    if (isError && error) {
      notification.error({
        message: 'Login failed',
        description: 'Please check your credentials.',
        placement: 'bottomRight',
      });
      setLoading(false);
    }
    if (isSuccess) {
      notification.success({
        message: 'Success',
        description: `Hello ${data.user.username}`,
        placement: 'bottomRight',
      });
      setLoading(false);
      useAuth.login(data.token, data.user);
      navigate('/', { replace: true });
    }
  }, [isError, error, isSuccess, data]);

  return (
    <Form
      className="login-form w-[400px]"
      form={form}
      name="horizontal_login"
      onFinish={onFinish}
    >
      <Form.Item
        name="username"
        rules={[{ required: true, message: 'Please input your username!' }]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="Username"
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="Password"
        />
      </Form.Item>
      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            style={{
              width: '100%',
              color: 'white',
              backgroundColor:
                !clientReady || isLoading ? '#B6B6B6' : '#A23231',
            }}
            disabled={
              !clientReady ||
              !form.isFieldsTouched(true) ||
              !!form.getFieldsError().filter(({ errors }) => errors.length)
                .length
            }
            loading={isLoading}
          >
            Log in
          </Button>
        )}
      </Form.Item>
    </Form>
  );
};

export default LoginForm;
